import { View } from 'react-native'
import React from 'react'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'

import { routes2 } from '@linqpal/models'
import { customStyles } from './customStyles'
import { BtApiTable } from '@linqpal/components/src/ui'

import projectsStore from '../../../Store'

import { styles } from './styles'
import { currencyMask } from '../../../../../utils/helpers/masking'

export const ProjectAddRemoveTable = observer(() => {
  const { t } = useTranslation('global')

  const { updateSelectedInvoices, type, refresher } = projectsStore

  const columns = [
    {
      name: t('Projects.InvOrSONo'),
      selector: 'invoice_number',
      sortable: true,
    },
    {
      name:
        type === 'payable' ? t('Projects.supplier') : t('Projects.Customer'),
      selector: 'customer',
      cell: (row) => row?.business_name,
      sortable: true,
    },
    {
      name: t('TransactionsView.amount'),
      selector: (item) => currencyMask(item?.total_amount),
    },
  ]

  return (
    <View style={styles.mainWrapper}>
      <BtApiTable
        filterWidth={'100%'}
        selectableRows
        selectableRowsComponentProps={{
          'aria-selected': (item) => (item ? 'true' : 'false'),
        }}
        onSelectedRowsChange={updateSelectedInvoices}
        extraApiParams={{
          category: type,
        }}
        columns={columns}
        refresher={refresher}
        style={customStyles}
        defaultSortColumn={'createdAt' as any}
        onItemPress={(item) => updateSelectedInvoices(item)}
        apiCaller={(params) =>
          routes2.invoice.findAll({ ...params, project_id: null })
        }
        filterPlaceholder={t('Projects.SearchInvoiceSOInputText')}
      />
    </View>
  )
})
